import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { InfoBanner } from 'ui/banner';
import { Member } from '../../types';
import { fullName } from '../../utils';

const Wrapper = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

export const Banners = ({ member }: { member: Member }) => {
  if (member?.lastLoginAt || member?.projectMemberships.length > 0) return null;

  return (
    <Wrapper>
      <InfoBanner>
        Invite {fullName(member)} to at least one project before sending an invitation.
      </InfoBanner>
    </Wrapper>
  );
};
